<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.extraFields')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-cogs"></i>
          <span>{{$ml.get('shared.definitions')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.extraFields')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-4">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{$ml.get('extraFields.extraFieldList')}}</span>
              </h3>
              <div class="box-tools pull-right">
              </div>
            </div>
            <div class="box-body">
              <input
                  type="text"
                  :placeholder="$ml.get('general.search')"
                  v-model="searchText"
                  class="form-control"
                  autocomplete="false"
                  style="margin-bottom:10px;"
                />
              <div
                v-show="extraFieldList.length > 0"
                class="table-responsive no-padding"
                :style="windowHeightSize"
              >
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="extraField in extraFieldList" :key="extraField.id">
                      <td>{{extraField.name}}</td>
                      <td class="pull-right">
                        <button
                          type="button"
                          @click="selectExtraField(extraField)"
                          class="btn btn-primary btn-sm"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="extraFieldList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{$ml.get('extraFields.extraFieldNotRecord')}}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>{{$ml.get('extraFields.extraFieldInfo')}}</span>
              </h3>
              <div class="box-tools pull-right">
                <button
                  v-show="authControl == 0"
                  type="button"
                  @click="newExtraField()"
                  class="btn btn-sm btn-warning "
                >{{$ml.get('extraFields.newGroup')}}</button>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>{{$ml.get('extraFields.groupName')}}</label>
                      <input
                        v-model="selectedExtraField.name"
                        type="text"
                        class="form-control"
                        autocomplete="off"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="overlay" id="load" :hidden="!isLoading">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div class="box-footer">
                <div class="pull-right">
                  <button
                    v-show="!isNewExtraField && authControl == 0"
                    type="button"
                    data-toggle="modal"
                    data-target="#modal-sil"
                    class="btn btn-sm btn-danger "
                    style="margin: 5px; width:120px;"
                  >{{$ml.get('general.delete')}}</button>
                  <button
                    v-show="isNewExtraField && authControl == 0"
                    type="button"
                    data-toggle="modal"
                    data-target="#modal-kaydet"
                    class="btn btn-sm btn-success "
                    style="margin: 5px; width:120px;"
                  >{{$ml.get('general.save')}}</button>
                  <button
                    v-show="!isNewExtraField && authControl == 0"
                    type="button"
                    data-toggle="modal"
                    data-target="#modal-guncelle"
                    class="btn btn-sm btn-success "
                    style="margin: 5px; width:120px;"
                  >{{$ml.get('general.update')}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.update')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.selectedExtraField.name}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('extraFields.isContinueUpdate')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="saveExtraField()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{$ml.get('general.update')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.save')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{this.selectedExtraField.name}}</p>
              <span>{{$ml.get('extraFields.isContinueSave')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="saveExtraField()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{$ml.get('general.save')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.delete')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.selectedExtraField.name}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('extraFields.isContinueDelete')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="deleteExtraField()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{$ml.get('general.delete')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      searchText: "",
      selectedExtraField: {
        id: null,
        name: ""
      },
      extraFields: [],
      isNewExtraField: true
    };
  },
  computed: {
    authControl() {
      return this.$store.getters.getAuthAyarlar;
    },
    extraFieldList() {
      if (this.searchText) {
        return this.extraFields.filter(item => {
          return this.searchText
            .toUpperCase()
            .split(" ")
            .every(v => item.name.toUpperCase().includes(v));
        });
      } else {
        return this.extraFields;
      }
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    selectExtraField(extraField) {
      this.isNewExtraField = false;
      this.selectedExtraField.id = extraField.id;
      this.selectedExtraField.name = extraField.name;
    },
    newExtraField() {
      this.isNewExtraField = true;
      this.selectedExtraField.id = null;
      this.selectedExtraField.name = "";
    },
    async saveExtraField() {
      if (this.selectedExtraField.name == "") {
        alertify.warning(this.$ml.get("alerts.pleaseEnterAName"));
        return;
      }
      this.isLoading = true;
      if (this.isNewExtraField) {
        try {
          let selectedExtraField2 = this.selectedExtraField;
          await this.$axios
            .post("/ExtraField", {
              definition: selectedExtraField2.name
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.savedSuccessfully"));
                this.getExtraFields();
                this.newExtraField();
              } else {
                alertify.error(response.message);
              }
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          this.isLoading = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoading = false;
        }
      } else {
        //GÜNCELLE
        try {
          let selectedExtraField2 = this.selectedExtraField;
          const response = await this.$axios
            .post("/ExtraField/" + selectedExtraField2.id, {
              definition: selectedExtraField2.name
            })
            .then(response => {
              if (response.status == 200) {
                alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
                this.getExtraFields();
              } else {
                alertify.error(response.message);
              }
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          this.isLoading = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoading = false;
        }
      }
    },
    async deleteExtraField() {
      try {
        this.isLoading = true;
        let id = this.selectedExtraField.id;
        const response = await this.$axios
          .delete("/ExtraField/" + id)
          .then(response => {
            if (response.status == 200) {
              alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
              this.getExtraFields();
              this.newExtraField();
            } else {
              alertify.error(response.message);
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getExtraFields() {
      try {
        this.isLoading = true;
        const extraFields = [];
        const response = await this.$axios
          .get("/ExtraField")
          .then(response => {
            response.data.forEach(doc => {
              extraFields.push({
                id: doc.id,
                name: doc.definition
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.extraFields = extraFields;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(
          this.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage")
        );
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getExtraFields();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/extraFields/ExtraFields.vue